import { Component } from '@angular/core';
import { DescriptionComponent } from '../description.component';
import { TextService } from '../../../services/text.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/services/guard/auth.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-description-mobile',
  templateUrl: './description-mobile.component.html',
  styleUrls: ['./description-mobile.component.scss']
})
export class DescriptionMobileComponent extends DescriptionComponent {
  constructor(
    textService: TextService,
    translate: TranslateService,
    authService: AuthService,
    deviceDetectorService: DeviceDetectorService,
    route: ActivatedRoute
  ) {
    super(textService, translate, authService, deviceDetectorService, route);
  }
}
